module.exports = __webpack_public_path__ + "img/knok_install_angle_bracket_poster.698a63cd.png";